import React from 'react'
import useOnClickOutside from 'use-onclickoutside'
import './emojipicker.css'
export const OtsideClickClosingWrapper = (props) => {
    const ref = React.useRef(null)
    
    const closeFunction=(e)=>{
        let flag = false;
        if(props.fromListViewOfTasks){ 
            let isPopover = e?.target?.closest('.ant-popover'); 
            let isPopoverChild = e?.target?.closest('.ant-popover-inner');  
            let isInsideComponent = e?.target?.closest('.Do-Not-Close'); 
            let isInsideEditor = e?.target?.closest('.jodit-text-editor-wrapper');
            let isInsideDropdown = e?.target?.closest('.jodit-popup');
            let isInsideContent = e?.target?.closest('.jodit-popup__content');
            let isInsideButton = e?.target?.closest('.jodit-toolbar-button');
            if(isPopover || isPopoverChild || isInsideComponent || isInsideEditor || isInsideDropdown || isInsideContent || isInsideButton){
                flag = true;
            }
        }
    let c = e?.target?.closest('.chat-overlay');
        let s = e?.target?.closest('.swal-modal');
        let a = props.forceClose? null :e?.target?.closest('.Do-Not-Close');
        let isKey = e?.target?.closest(`.${props.avoidClasses}`);
        let k = e?.target?.closest('.create-user-group-icon');
        let t = e?.target?.closest('.list-icon');
        if(flag || c || a || k || t || s || isKey){
            return
        }else{
            props.close(e)
        }
    }
    useOnClickOutside(ref, closeFunction)
    return <div ref={ref} {...props} >
        {props.children}
    </div>
}